import saveAs from 'file-saver';

async function downloadImageFromUrl(url: string) {
  const fileName = url.split('?')[0].split('/').pop() || '';
  const blob = await fetch(url).then((r) => r.blob());
  saveAs(blob, fileName);
}

export default downloadImageFromUrl;
